import React, { useState, useEffect } from "react";
import {
  DataGrid,
  GridActionsCellItem,
  GridDeleteIcon,
  GridToolbar
} from "@mui/x-data-grid";
import ConfirmationModal from "../confirmation-modal/ConfirmationModal";
import SuccessAlert from "../success-alert/SuccessAlert";
import ErrorAlert from "../error-alert/ErrorAlert";
import { API } from "../../assets/staticData";
import EditIcon from "@mui/icons-material/Edit";
import EditCats from "../editors/EditCats";
import EditRedirect from "../editors/EditRedirect";

export default function RedirectsDataTable({
  data,
  setRefresh,
  refresh,
  user,
  onChangeQuery,
  meta,
  loading
}) {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [confirmed2, setConfirmed2] = useState(false);
  const [clickedEntryId, setClickedEntryId] = useState();
  const [selected, setSelected] = useState([]);
  const [deleteSelected, setDeleteSelected] = useState(false);
  const [item, setItem] = useState({});

  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);

  let userToken = localStorage.getItem("userToken");

  const headers = {
    Authorization: `Bearer ${userToken}`,
  };

  const columns = [
    { field: "id", headerName: "ID", width: 70 },

    { field: "source", headerName: "Source URL", width: 330 },
    {
      field: "destination",
      headerName: "Destination",
      width: 250,
    },
    {
      field: "type",
      headerName: "Type",
      width: 100,
    },
    {
      field: "actions",
      type: "actions",
      headerName: user.perms[26].edit || user.perms[26].delete ? "Actions" : "",
      cellClassName: "actions",
      width: 130,
      getActions: ({ id }) => {
        return [
          <>
            {user.perms[26].edit && (
              <GridActionsCellItem
                icon={<EditIcon />}
                label="Delete"
                onClick={() => setItem({ id })}
              />
            )}
          </>,
          <>
            {user.perms[26].delete && (
              <GridActionsCellItem
                icon={<GridDeleteIcon />}
                label="Delete"
                onClick={handleDeleteClick(id)}
              />
            )}
          </>,
        ];
      },
    },
  ];

  const handleDeleteClick = (id) => () => {
    setOpen(true);
    setClickedEntryId(id);
  };

  useEffect(() => {
    async function deleteEntry() {
      if (confirmed == true) {
        fetch(`${API}/redirects/${clickedEntryId}`, {
          headers,
          method: "DELETE",
        }).then(async (res) => {
          if (res.ok) {
            setSuccess(true);
            setRows(rows.filter((row) => row.id !== clickedEntryId));
            setConfirmed(false);

            if (onChangeQuery && meta) {
              onChangeQuery(meta.pagination)
            }
          } else {
            setFail(true);
            setConfirmed(false);
          }
        });
      }
    }

    deleteEntry();
  }, [confirmed, meta, onChangeQuery]);

  useEffect(() => {
    let docs = [];
    data?.forEach((item, index) => {
      docs = [
        ...docs,
        {
          id: item.id,
          source: item.attributes.source,
          destination: item.attributes.destination,
          type: item.attributes.type,

        },
      ];
    });
    setRows(docs);
  }, [data]);

  const deleteSelectedItems = async () => {
    setOpen2(true);
  };

  useEffect(() => {
    async function deleteSelected() {
      if (confirmed2 == true) {
        setDeleteSelected(false);
        try {
          await Promise.all(
            selected.map(async (item) => {
              await fetch(`${API}/redirects/${item}`, {
                headers,
                method: "DELETE",
              });
            })
          );

          const updatedRows = rows.filter((row) => !selected.includes(row.id));
          setRows(updatedRows);
          setSelected([]);
          setSuccess(true);

          if (onChangeQuery && meta) {
            onChangeQuery(meta.pagination)
          }
        } catch (error) {
          console.error("Error deleting items:", error);
        }
      }
    }

    deleteSelected();
  }, [confirmed2]);

  return (
    <div style={{ width: "100%" }}>
      <SuccessAlert show={success} setShow={(v) => setSuccess(v)} />
      <ErrorAlert show={fail} setShow={(v) => setFail(v)} />

      <DataGrid
        sx={{ minHeight: 580 }}
        disableColumnSorting
        disableAutosize
        disableColumnFilter
        onRowSelectionModelChange={(v) => {
          setSelected(v);
          if (v.length > 0) {
            setDeleteSelected(true);
          } else {
            setDeleteSelected(false);
          }
        }}
        rows={rows}
        loading={loading}
        columns={columns}
        paginationMode="server"
        pageSize={meta.pagination.pageSize}
        rowCount={meta.pagination.total}
        paginationModel={{
          page: meta.pagination.page - 1,
          pageSize: meta.pagination.pageSize
        }}
        onPaginationModelChange={(args) => {
          onChangeQuery({ ...args, page: args.page + 1 })
        }}
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          toolbar: {
            showQuickFilter: true,
            csvOptions: { disableToolbarButton: true },
            printOptions: { disableToolbarButton: true },
          },
        }}
        pageSizeOptions={[10]}
        checkboxSelection
      />
      {deleteSelected && user.perms[26].delete && (
        <div onClick={deleteSelectedItems} className="deleteBTN">
          Delete Selected Items
        </div>
      )}
      <ConfirmationModal
        message={"Are you sure you want to delete this item?"}
        open={open}
        setOpen={setOpen}
        setConfirmed={(v) => setConfirmed(v)}
      />
      <ConfirmationModal
        message={"Are you sure you want to delete the selected items?"}
        open={open2}
        setOpen={setOpen2}
        setConfirmed={(v) => setConfirmed2(v)}
      />

      <EditRedirect
        endpoint={"redirects"}
        itemToEdit={item}
        setItemToEdit={setItem}
        setRefresh={setRefresh}
        refresh={refresh}
      />
    </div>
  );
}
